<div class="flex flex-col gap-4">
  @if (creations().length > 0) {
    <div class="space-y-3">
      <div class="flex items-center gap-2">
        <IIcon name="checkCircle" class="text-lg text-green-500" />
        <span class="font-medium tracking-tight text-gray-700"
          >{{ creations().length }} creation{{ creations().length > 1 ? "s" : "" }}</span
        >
      </div>

      <div class="max-h-[300px] min-w-0 overflow-auto">
        <table class="w-full">
          <thead>
            @for (field of fields(); track field) {
              <th class="pr-5 text-left text-sm font-normal tracking-tight text-nowrap text-gray-400">
                {{ field.title }}
              </th>
            }
          </thead>

          <tbody>
            @for (creation of creations(); track creation) {
              <tr class="border-b border-gray-200">
                @for (field of fields(); track field) {
                  <td
                    class="py-3 pr-5 text-sm font-medium tracking-tight text-gray-700"
                    [ngClass]="{ 'max-w-[200px] truncate whitespace-nowrap': field.field === 'name' }"
                  >
                    {{ field.csvField.value(creation.createdEntity) }}
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }

  @if (updates() && updates().length > 0) {
    <div class="space-y-3">
      <div class="flex items-center gap-2">
        <IIcon name="checkCircle" class="text-lg text-blue-500" />
        <span class="font-medium tracking-tight text-gray-700"
          >{{ updates().length }} update{{ updates().length > 1 ? "s" : "" }}</span
        >
      </div>

      <div class="max-h-[300px] min-w-0 overflow-auto">
        <table class="w-full">
          <thead>
            @for (field of fields(); track field) {
              <th class="pr-5 text-left text-sm font-normal tracking-tight text-nowrap text-gray-400">
                {{ field.title }}
              </th>
            }
          </thead>

          <tbody>
            @for (update of updates(); track update) {
              <ng-template
                [ngTemplateOutlet]="diffRow"
                [ngTemplateOutletContext]="{ $implicit: update, isOrginalRow: true }"
              ></ng-template>
              <ng-template
                [ngTemplateOutlet]="diffRow"
                [ngTemplateOutletContext]="{ $implicit: update, isOrginalRow: false }"
              ></ng-template>
              <tr class="border-b border-gray-200"></tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }

  @if (errors() && errors().length > 0) {
    <div class="space-y-3">
      <div class="flex items-center gap-2">
        <IIcon name="closeCircle" class="text-lg text-red-500" />
        <span class="font-medium tracking-tight text-gray-700"
          >{{ errors().length }} line{{ errors().length > 1 ? "s" : "" }} skipped due to errors</span
        >

        <button iButton size="icon-sm" variant="ghost" (click)="isErrorAccordionOpen.set(!isErrorAccordionOpen())">
          <IIcon [name]="isErrorAccordionOpen() ? 'chevronDown' : 'chevronRight'" />
        </button>
      </div>

      <IAccordion [isOpen]="isErrorAccordionOpen()">
        <ul class="flex max-h-[300px] flex-col gap-2 overflow-auto text-sm">
          @for (error of errors(); track error) {
            <li>
              <span class="text-gray-500">#{{ error.lineIndex }}</span>
              <span class="bg-gray-50 text-gray-800"> {{ error.csvRow }}</span>
              <div class="text-red-500">{{ error.error }}</div>
            </li>
          }
        </ul>
      </IAccordion>
    </div>
  }
</div>

<ng-template #diffRow let-diff let-isOrginalRow="isOrginalRow">
  <tr>
    @for (field of fields(); track field) {
      <td
        class="pr-5 text-sm font-medium tracking-tight text-gray-700"
        [ngClass]="{
          'max-w-[200px] truncate whitespace-nowrap': field.field === 'name',
          'pt-3 pb-1.5': isOrginalRow,
          'pt-1.5 pb-3': !isOrginalRow,
        }"
      >
        @if (diff.original[field.field] !== diff.updated[field.field] && diff.updated[field.field] !== undefined) {
          @if (isOrginalRow) {
            <span class="bg-red-100 stroke-slate-100 text-gray-500 line-through">
              {{ field.csvField.value(diff.original) }}
            </span>
          } @else {
            <span class="bg-green-100 text-gray-500">
              {{ field.csvField.value(diff.updated) }}
            </span>
          }
        } @else if (field.field === entityIdField() && !isOrginalRow) {
          <span class="pl-3 text-gray-600"> |___ </span>
        } @else {
          <span class="text-gray-500">
            {{ field.csvField.value(diff.original) }}
          </span>
        }
      </td>
    }
  </tr>
</ng-template>
